"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendar_hammer = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var calendar_hammer = function calendar_hammer(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'calendar-hammer-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M10.8282 7.45711L13.6566 10.2855C14.0472 10.6761 14.0472 11.3092 13.6566 11.6997L12.9495 12.4069C12.559 12.7974 11.9258 12.7974 11.5353 12.4069L10.9142 11.7857L7.70726 14.9926C7.31673 15.3832 6.68357 15.3832 6.29304 14.9926C5.90252 14.6021 5.90252 13.9689 6.29304 13.5784L9.49996 10.3715L8.70688 9.57843C8.31636 9.1879 8.31636 8.55474 8.70688 8.16421L9.41399 7.45711C9.80451 7.06658 10.4377 7.06658 10.8282 7.45711Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M13.25 3H6.75V2.75C6.75 2.33579 6.41421 2 6 2C5.58579 2 5.25 2.33579 5.25 2.75V3H2C1.58579 3 1.25 3.33579 1.25 3.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V3.75C18.75 3.33579 18.4142 3 18 3H14.75V2.75C14.75 2.33579 14.4142 2 14 2C13.5858 2 13.25 2.33579 13.25 2.75V3ZM6.75 4.75V4.5H13.25V4.75C13.25 5.16421 13.5858 5.5 14 5.5C14.4142 5.5 14.75 5.16421 14.75 4.75V4.5H17.25V17H2.75V4.5H5.25V4.75C5.25 5.16421 5.58579 5.5 6 5.5C6.41421 5.5 6.75 5.16421 6.75 4.75Z',
    fill: '#4B5563'
  }));
};

exports.calendar_hammer = calendar_hammer;